import React from 'react'
import { useProduct } from '../../../../__product/useProduct'
import { ResponsivePictureSizes } from '../../../Picture/responsive'
import {
    StyledGridItem,
    StyledJabTrackerContainer,
    StyledSource,
    StyledSyringeImg,
    StyledTitleGridItem,
} from '../perthnow/JabTracker.styled'
import {
    StyledGridItem as StyledTWGridItem,
    StyledGridTitleItem as StyledTWGridTitleItem,
    StyledJabTrackerContainer as StyledTWJabTrackerContainer,
    StyledTitle as StyledTWTitle,
} from '../thewest/JabTracker.styled'
import { SkeletonComponent } from './SkeletonComponent'

interface LoadingSkeletonProps {
    type: 'large' | 'small'
    containerRatios: ResponsivePictureSizes
}

export function JabTrackerSkeleton({
    type,
    containerRatios,
}: LoadingSkeletonProps) {
    const product = useProduct()

    const theWestImageSM = require('../thewest/assets/thewest_covidtracker-sm.png')
    const theWestImageLG = require('../thewest/assets/thewest_covidtracker-lg.png')
    const perthNowSyringeImg = require('../perthnow/assets/syringe.png')

    const PNLoadingHeights = {
        cases: type === 'large' ? 90 : 127,
        vax: type === 'large' ? 125 : 125,
    }

    if (product === 'thewest') {
        return (
            <StyledTWJabTrackerContainer
                containerRatios={containerRatios}
                isLoading={true}
                type={type}
            >
                <StyledTWGridTitleItem type={type}>
                    <StyledTWTitle>COVID-19 Tracker</StyledTWTitle>
                    <img
                        className="jabtracker-image"
                        src={type === 'large' ? theWestImageLG : theWestImageSM}
                        alt="covid tracker decorative image"
                    />
                </StyledTWGridTitleItem>
                <StyledTWGridItem>
                    <SkeletonComponent />
                </StyledTWGridItem>
                <StyledTWGridItem>
                    <SkeletonComponent />
                </StyledTWGridItem>
            </StyledTWJabTrackerContainer>
        )
    }
    return (
        <StyledJabTrackerContainer
            type={type}
            isLoading={true}
            containerRatios={containerRatios}
        >
            <StyledTitleGridItem type={type}>
                <div>
                    <h3>COVID 19 TRACKER</h3>
                    <p>
                        <span>active cases</span>
                        <span> Local active cases as of today</span>
                    </p>
                </div>
                <StyledSyringeImg
                    src={perthNowSyringeImg}
                    alt="Covid syringe"
                />
            </StyledTitleGridItem>

            <StyledGridItem>
                <SkeletonComponent
                    height={`${PNLoadingHeights.cases.toString()}px`}
                    baseColor="#273640"
                    highlightColor="#1B262E"
                />
            </StyledGridItem>

            <StyledGridItem>
                <SkeletonComponent
                    height={`${PNLoadingHeights.vax.toString()}px`}
                    baseColor="#273640"
                    highlightColor="#1B262E"
                />
            </StyledGridItem>

            <StyledSource>
                Source: <a href="https://covidlive.com.au">covidlive.com.au</a>
            </StyledSource>
        </StyledJabTrackerContainer>
    )
}
